import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'business-sample-project.controllers.create-jwm-sample-project.error-flag-title',
		defaultMessage: 'Something went wrong',
		description: 'Title shown in error flag when creating sample project fails',
	},
	errorFlagText: {
		id: 'business-sample-project.controllers.create-jwm-sample-project.error-flag-text',
		defaultMessage:
			'Please reload the page to try again. If you’re still having trouble, please contact Atlassian support to resolve this.',
		description: 'Message shown in error flag when creating sample project fails',
	},
});
